import { DocumentKind, LoadStatus, Role } from "../enums.js";
import { SettlementStatus } from "../enums.js";
const ALLOWED = {
    [LoadStatus.considering]: [LoadStatus.booked, LoadStatus.passed],
    [LoadStatus.passed]: [LoadStatus.considering],
    [LoadStatus.booked]: [
        LoadStatus.rolling,
        LoadStatus.cancelled,
        LoadStatus.considering,
    ],
    [LoadStatus.rolling]: [LoadStatus.delivered, LoadStatus.cancelled],
    [LoadStatus.delivered]: [LoadStatus.paid, LoadStatus.rolling],
    [LoadStatus.paid]: [],
    [LoadStatus.cancelled]: [LoadStatus.considering],
};
export function allowedTransitions(from) {
    return ALLOWED[from];
}
/**
 * Check whether a status transition is allowed and required fields are present.
 * Drivers only own loads, never to paid.
 */
export function canTransition(load, to, ctx) {
    const from = load.status;
    if (!ALLOWED[from].includes(to)) {
        return {
            ok: false,
            code: "INVALID_TRANSITION",
            message: `Cannot transition from ${from} to ${to}`,
        };
    }
    if (ctx.role === Role.driver) {
        if (ctx.actorDriverId != null &&
            load.driverId != null &&
            load.driverId !== ctx.actorDriverId) {
            return {
                ok: false,
                code: "FORBIDDEN",
                message: "Drivers may only transition their own loads",
            };
        }
        if (to === LoadStatus.paid) {
            return {
                ok: false,
                code: "FORBIDDEN",
                message: "Drivers cannot mark loads paid",
            };
        }
    }
    if (to === LoadStatus.booked) {
        const missing = [];
        if (!(load.linehaulCents > 0))
            missing.push("linehaulCents");
        if (!load.origin?.text)
            missing.push("origin.text");
        if (!load.destination?.text)
            missing.push("destination.text");
        if (!load.payContractId)
            missing.push("payContractId");
        if (missing.length > 0) {
            return {
                ok: false,
                code: "MISSING_FIELDS",
                message: "Booking requires linehaul, origin, destination, and pay contract",
                missing,
            };
        }
        return {
            ok: true,
            to,
            effects: { setBookedAt: true, enqueueRouteCompute: true },
        };
    }
    if (to === LoadStatus.delivered) {
        const docs = ctx.documents ?? [];
        const hasPod = docs.some((d) => d.kind === DocumentKind.pod && d.deletedAt == null);
        if (!hasPod) {
            return {
                ok: false,
                code: "MISSING_FIELDS",
                message: "Delivery requires a POD document",
                missing: ["pod"],
            };
        }
        return {
            ok: true,
            to,
            effects: { setDeliveredAt: true, attachDraftSettlement: true },
        };
    }
    if (from === LoadStatus.delivered && to === LoadStatus.rolling) {
        // Undo delivered. Once the week's settlement is finalized or paid the
        // load's money is settled; it can't go back on the road.
        if (ctx.settlement && ctx.settlement.status !== SettlementStatus.draft) {
            return {
                ok: false,
                code: "INVALID_TRANSITION",
                message: "This load is on a finalized settlement and can't be undone",
            };
        }
        return { ok: true, to, effects: { clearDeliveredAt: true, detachSettlement: true } };
    }
    if (from === LoadStatus.booked && to === LoadStatus.considering) {
        return { ok: true, to, effects: { clearBookedAt: true } };
    }
    if (to === LoadStatus.paid) {
        if (!ctx.settlement ||
            ctx.settlement.status !== SettlementStatus.paid) {
            return {
                ok: false,
                code: "MISSING_FIELDS",
                message: "Marking paid requires a paid settlement",
                missing: ["settlement.paid"],
            };
        }
        return {
            ok: true,
            to,
            effects: { lockMoney: true },
        };
    }
    return { ok: true, to, effects: {} };
}
//# sourceMappingURL=transitions.js.map